import { ClientRequestItemStatus, RequestItem } from '@aiwyn/api';
import { AuthService } from '@aiwyn/auth';
import { inject, Injectable } from '@angular/core';
import { TrackService } from '@aiwyn/shared';
import { ClientRequestEvent } from '../models/client-request-event.model';

@Injectable({ providedIn: 'root' })
export class ClientRequestTrackingService {
  private readonly trackService = inject(TrackService);
  private readonly user = inject(AuthService).getUserSignal(true);

  trackRequestItemsSubmitted(
    clientRequestId: number,
    preSubmitItems: { itemId: number; item: RequestItem }[],
  ): void {
    const contactId = this.user()?.getContactId() ?? null;

    for (const { itemId, item } of preSubmitItems) {
      const isResubmit = item.status !== ClientRequestItemStatus.OPEN;

      this.trackService.track(ClientRequestEvent.EVENT_REQUEST_ITEM_SUBMITTED, {
        cr_id: clientRequestId,
        cri_id: itemId,
        cri_submitted_by: contactId,
        cri_is_resubmitted: isResubmit,
        cri_submit: 'succeeded',
        ...(isResubmit ? { cri_resubmitted_by: contactId } : {}),
      });
    }
  }

  trackRequestItemsSubmitFailed(
    clientRequestId: number,
    preSubmitItems: { itemId: number; item: RequestItem }[],
    error: unknown,
  ): void {
    const contactId = this.user()?.getContactId() ?? null;
    const httpStatus = (error as { status?: unknown })?.status;
    const reason = typeof httpStatus === 'number' ? `http_${httpStatus}` : 'unknown';

    for (const { itemId, item } of preSubmitItems) {
      const isResubmit = item.status !== ClientRequestItemStatus.OPEN;

      this.trackService.track(ClientRequestEvent.EVENT_REQUEST_ITEM_SUBMITTED, {
        cr_id: clientRequestId,
        cri_id: itemId,
        cri_submitted_by: contactId,
        cri_is_resubmitted: isResubmit,
        cri_submit: 'failed',
        cri_submit_failed_reason: reason,
        ...(isResubmit ? { cri_resubmitted_by: contactId } : {}),
      });
    }
  }
}
